import { BaseReportActionsHandler } from '../base-report-actions-handler';
import { Inject, Injectable } from '@angular/core';
import { Override } from '../../../app-decorators';
import { IExtendedWindow, IObject } from '../../../../../type_definitions/datatypes';
import * as _ from 'underscore';
import { UrlService } from '../../../browser/url.service';
import { REPORT_ACTION_CANCELLED } from '../report-actions.helper';

@Injectable()
export class DownloadBpHandlerService extends BaseReportActionsHandler {

  constructor(
    private urlService: UrlService,
    @Inject(Window) private window: IExtendedWindow
  ) {
    super();
  }

  @Override(BaseReportActionsHandler)
  public execute(): Promise<string> {
    const url:string = this.urlService.getSupplierActivationFormUrl(this.extractBPIds(this.rowSelection));

    // open a new tab to download BP Supplier Form
    this.window.open(url);

    // Cancel report action to indicate for doing nothing afterwards
    return Promise.reject(REPORT_ACTION_CANCELLED);
  }

  private extractBPIds(rowSelection: IObject[]): number[] {
    const bpIds:number[] = [];

    _.each(rowSelection, (row: IObject) => {
      bpIds.push(row?.Denname?.properties?.bpprofileId);
    });

    return bpIds;
  }
}